import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { AuthorizationService } from './auth.service';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private authService: AuthorizationService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this.authService.currentUserValue;
    if (currentUser && currentUser.Token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.Token}`,
        },
      });
    }
    return next.handle(request).do(
      () => { }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          this.authService.SignOut(false);
          location.href = '/';
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.interceptor.ts